import $ from 'jquery'
import moment from 'moment'

const debug = require('debug')('pm:toolbar')
debug('loaded')

export const Toolbar = {
  firstRun: true,
  dateRangeLimit: 3,
  datepickerDefaults: {
    dateFormat: 'm/d/y',
    changeYear: true,
    changeMonth: true,
    numberOfMonths: 1,
    showAnim: '',
  },

  init: function () {
    debug('init')

    if ($('.toolbar').length === 0) {
      debug('no ".toolbar" found - exiting')
      return
    }

    const $toolbar = $('.toolbar')

    if (Toolbar.firstRun && $toolbar.data('delivery-stats-toolbar')) {
      Toolbar.firstRun = false

      Toolbar.dropdowns()
      Toolbar.dateRange()
    }
  },

  dropdowns: function () {
    function showDropdown(el) {
      // Protect from closing on clicks inside dropdown
      $(el)
        .showMe()
        .bind('click.insideMenu', function (event) {
          event.stopPropagation()
        })

      // Prepare to hide on clicks outside of dropdown
      $(document).bind('click.hideDropdown', function (event) {
        hideListener($(event.target)[0])
      })
    }
    function hideDropdowns() {
      if ($('.toolbar-dropdown-menu:visible').length) {
        $('.toolbar-dropdown-menu').hideMe().unbind('click.insideMenu')
        $(document).unbind('click.hideDropdown')
        $('.js-toolbar-dropdown').removeClass('is-active')

        Toolbar.resetDateRangeState()
      }
    }
    function hideListener(target) {
      if (
        $(target).hasClass('js-toolbar-dropdown') ||
        $(target).parents('.js-toolbar-dropdown').length
      ) {
        return
      }
      hideDropdowns()
    }

    $(document).on(
      'click.showDropdown',
      '.js-toolbar-dropdown',
      function (event) {
        event.preventDefault()

        const dropdownMenu = $(this).parent().find('.toolbar-dropdown-menu')

        if (dropdownMenu.is(':visible')) {
          hideDropdowns()
          $(this).removeClass('is-active')
        } else {
          hideDropdowns()
          showDropdown(dropdownMenu)
          $(this).addClass('is-active')
        }
      }
    )
  },

  dateRange: function () {
    if (!$('#datepicker-from').length || !$('#datepicker-to').length) {
      return
    }

    // Keep track of the initial state
    Toolbar.initialFromDate = $('#date-from').val()
    Toolbar.initialToDate = $('#date-to').val()
    Toolbar.initialRange = $('.js-activity-filter-range').val()

    // Extending Datepicker with afterShow call

    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker
    $.datepicker._updateDatepicker = function (inst) {
      $.datepicker._updateDatepicker_original(inst)
      this._afterShow(inst)
    }
    $.datepicker._afterShow = function (inst) {
      const afterShow = this._get(inst, 'afterShow')
      if (afterShow) {
        afterShow.apply(inst.input ? inst.input[0] : null, [
          inst.input ? inst.input.val() : '',
          inst,
          inst.dpDiv.find('td:has(a)'),
        ])
      }
    }

    function highlightRange() {
      const f = $('#date-from').val(), // m/d/yy
        t = $('#date-to').val(),
        from = Date.parse(moment(f, 'M/D/YY').format('YYYY-MM-DD')),
        to = Date.parse(moment(t, 'M/D/YY').format('YYYY-MM-DD'))

      $('.ui-datepicker-calendar tbody td').removeClass(
        'ui-datepicker-within-range'
      )

      $('.ui-datepicker-calendar tbody').each(function (i, el) {
        $(el)
          .find('td')
          .each(function () {
            let date, correctedDay, correctedMonth

            if (
              $(this).data('year') !== undefined &&
              $(this).data('month') !== undefined
            ) {
              correctedDay = $(this).text()
              correctedDay =
                correctedDay < 10 ? '0' + correctedDay : correctedDay

              correctedMonth = $(this).data('month') + 1
              correctedMonth =
                correctedMonth < 10 ? '0' + correctedMonth : correctedMonth

              date = Date.parse(
                $(this).data('year') + '-' + correctedMonth + '-' + correctedDay
              )

              if (date >= from && date <= to) {
                $(this).addClass('ui-datepicker-within-range')
              }
            }
          })
      })
    }

    // Setting defaults for jQuery UI Datepicker

    $.datepicker.setDefaults(Toolbar.datepickerDefaults)

    // Show and hide calendars

    $('#date-from, #date-to').on('keydown', function (event) {
      if ($.inArray(event.keyCode, [46, 8, 9, 27, 13, 191]) !== -1) {
        // Allow: backspace, delete, tab, escape, enter and backslash
        return
      } else if (
        (event.ctrlKey || event.metaKey) &&
        $.inArray(event.keyCode, [65, 67, 86, 88]) !== -1
      ) {
        // Allow: Ctrl+a, Ctrl+c, , Ctrl+v, , Ctrl+x
        return
      } else if (event.keyCode >= 35 && event.keyCode <= 39) {
        // Allow: home, end, left, right
        return
      } else if (
        event.shiftKey ||
        ((event.keyCode < 48 || event.keyCode > 57) &&
          (event.keyCode < 96 || event.keyCode > 105))
      ) {
        // Ensure that it is a number and stop the keypress
        event.preventDefault()
      }
    })

    $('#date-from')
      .on('focus', function () {
        $('#datepicker-to').hideMe()
        $('#datepicker-from').showMe()
        $(this).addClass('is-active')
        $('#date-to').removeClass('is-active')
      })
      .on('change', function () {
        $('#datepicker-from').datepicker('setDate', $(this).val())
        Toolbar.dateRangeState()
      })

    $('#date-to')
      .on('focus', function () {
        $('#datepicker-from').hideMe()
        $('#datepicker-to').showMe()
        $(this).addClass('is-active')
        $('#date-from').removeClass('is-active')
      })
      .on('change', function () {
        $('#datepicker-to').datepicker('setDate', $(this).val())
        Toolbar.dateRangeState()
      })

    // Add support for date ranges

    $('#datepicker-from').datepicker({
      altField: '#date-from',
      defaultDate: $('#date-from').val(),
      minDate: $('#date-from').data('min-date'),
      maxDate: $('#date-to').val(),
      afterShow: function () {
        highlightRange()
      },
      onSelect: function (from) {
        const fromDate = moment(from, 'M/D/YY').toDate(),
          toDate = moment($('#datepicker-to').val(), 'M/D/YY').toDate()

        $('#datepicker-to').datepicker('option', 'minDate', fromDate)

        $('#date-to').focus()
        Toolbar.dateRangeState()

        if (Toolbar.dateRangeLimit > 0) {
          // Reset To date only if it is not within allowed months range
          const maxToDate = moment(fromDate)
            .add('months', Toolbar.dateRangeLimit)
            .toDate()
          if (maxToDate < toDate)
            $('#datepicker-to').datepicker('setDate', maxToDate)
        }
      },
    })

    $('#datepicker-to').datepicker({
      altField: '#date-to',
      defaultDate: $('#date-to').val(),
      minDate: $('#date-from').val(),
      maxDate: 0,
      afterShow: function () {
        highlightRange()
      },
      onSelect: function (to) {
        const toDate = moment(to, 'M/D/YY').toDate(),
          fromDate = moment($('#datepicker-from').val(), 'M/D/YY').toDate()

        $('#datepicker-from').datepicker('option', 'maxDate', toDate)
        Toolbar.dateRangeState()

        if (Toolbar.dateRangeLimit > 0) {
          // Reset From date only if it is not within allowed months range
          const minFromDate = moment(toDate)
            .subtract('months', Toolbar.dateRangeLimit)
            .toDate()
          if (minFromDate > fromDate)
            $('#datepicker-from').datepicker('setDate', minFromDate)
        }
      },
    })
  },

  dateRangeState: function () {
    const from = '#date-from'
    const to = '#date-to'
    const $range = $('.js-activity-filter-range')

    if (
      $(from).val() !== Toolbar.initialFromDate ||
      $(to).val() !== Toolbar.initialToDate
    ) {
      $range.val('custom')
    } else {
      $range.val(Toolbar.initialRange)
    }
  },

  resetDateRangeState: function () {
    // Reset input values
    $('#date-from').val(Toolbar.initialFromDate)
    $('#date-to').val(Toolbar.initialToDate)

    // Reset date picker
    $('#datepicker-from').datepicker('setDate', Toolbar.initialFromDate)
    $('#datepicker-to').datepicker('setDate', Toolbar.initialToDate)
    $('.js-activity-filter-range').val(Toolbar.initialRange)

    // Hide datepicker and remove active class
    $('.hasDatepicker').addClass('hidden')
    $('.date-range-field').removeClass('is-active')
  },
}

$(Toolbar.init)
